import withPromoSectionProps from 'viewModel/checkout/promoSection/withPromoSectionProps';
import PromoSection from 'components/Checkout/PromoSection/PromoSection';

export default withPromoSectionProps(PromoSection);
